import React from 'react';
import { Modal } from 'antd';
import CreateUser from '../pages/NewUser/NewUser';

const AdjusterModal = ({ open, handleClose, parentId, onSubmit,currentUserId, isEditModalOpen, isEditingAdjuster}) => {
    return (
        <Modal
        open={open}
        onCancel={handleClose}
        centered
        footer={null}
        destroyOnClose={true}
        >
            <CreateUser handleClose={handleClose} isEditingAdjuster={isEditingAdjuster} isEditModalOpen={isEditModalOpen} parentId={parentId} create={currentUserId ? "update" : "create"} currentUserId={currentUserId} onSubmit={onSubmit} open={open} user="Adjuster" userRoles={[4]} />
        </Modal>
    );
};

export default AdjusterModal;